import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import UserIcon from "../../user/user_icon";
import { ICON_SIZES } from "../../../modules/shape_icon_values";
import StartAnsweringButton from "./start_answering_button";
import Reflux from "reflux";
import AskTheAuthorBannerStore from "../../../react_stores/ask_the_author_banner_store";
import AskTheAuthorBannerActions from "../../../react_actions/ask_the_author_banner_actions";

export default GrComponentFactory.createClass({
  displayName: "AskTheAuthorInvitationBanner",
  mixins: [Reflux.connect(AskTheAuthorBannerStore, "askTheAuthorBannerStore")],

  propTypes() {
    GrPropTypes.user().isRequired;
    React.PropTypes.number.isRequired;
  },

  render() {
    const state = this.state.askTheAuthorBannerStore;
    if(state.isBannerShown) {
      return <div className="askTheAuthorBanner">
        <div className="askTheAuthorBanner__icon">
          <div className="gr-mediaBox__media">
            <UserIcon user={this.props.authorUser} size={ICON_SIZES.MEDIUM}/>
          </div>
        </div>
        <div className="askTheAuthorBanner__title">
          Hey {this.props.authorUser.informalName}! Engage with your readers. Activate Ask the Author to answer their questions.
        </div>
        <div className="askTheAuthorBanner__button">
          <StartAnsweringButton authorID={this.props.authorID}/>
            <button className="gr-buttonAsLink askTheAuthorBanner__link"
                    onClick={AskTheAuthorBannerActions.hideBanner}>
              Skip For Now
            </button>
        </div>
      </div>;
    } else {
      return null;
    }
  },
});
